export default {
  meta: {
    title: '开放页面-企业认证'
  }
};
